<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
    data: function(){
        return {
            dropdownOpen: false,
            selected: 1
        }
    },
    methods: {
        addClass($event) {
            if ($event.target.classList.contains('community-card')) {
                $($event.target).addClass('hover');
            } else {
                $($event.target).parents('.community-card').addClass('hover');
            }
        },
        removeClass($event) {
            if ($event.target.classList.contains('community-card')) {
                $($event.target).removeClass('hover');
            } else {
                $($event.target).parents('.community-card').removeClass('hover');
            }
        }
    }
};

</script>



// WEBPACK FOOTER //
// resources/components/apps/community-card.vue